import { SettingsParser } from "./settings-parser";
import { DataSettingsParser } from "./data-settings-parser";
import { FilteredDataSettings } from "../settings/filtered-data-settings";

export class FilteredDataSettingsParser extends DataSettingsParser {
  constructor(filterParser, sourceParser, unitParser) {
    super(sourceParser, unitParser);
    this.parsedFieldNames.push("filters");
    this.filterParser = filterParser;
  }

  static createSettings(settings, defaultSettings, filterParser, sourceParser, unitParser) {
    let parsedSettings = DataSettingsParser.createSettings(settings, defaultSettings, sourceParser, unitParser);
    if (parsedSettings === undefined) {
      return undefined;
    }
    parsedSettings.filters = [];
    if (settings.filters !== undefined && filterParser !== undefined) {
      for (let filterIndex = 0; filterIndex < settings.filters.length; filterIndex++) {
        let filterSettings = settings.filters[filterIndex];
        parsedSettings.filters.push(filterParser.parse(filterSettings, defaultSettings?.filter));
      }
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = FilteredDataSettingsParser.createSettings(
      settings,
      defaultSettings,
      this.filterParser,
      this.sourceParser,
      this.unitParser
    );
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new FilteredDataSettings(parsedSettings);
  }
}
